import {default as App} from './App/App'
import {default as About} from './About/About'
import {default as Posts} from './Posts/Posts'

module.exports = {
    About,
    App,
    Posts
};



/** WEBPACK FOOTER **
 ** ./src/app/components/index.js
 **/